const items = ["Creative Vision", "AI Production", "Digital Optimization", "Broadcast Delivery"];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-white/10 py-7"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {items.map((text, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-8 font-serif text-2xl italic text-zinc-500 md:px-12 md:text-3xl">
                  {text}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-zinc-700" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
